/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The EventsControllerDtoDrawItemDetailRequest model module.
 * @module model/EventsControllerDtoDrawItemDetailRequest
 * @version 1.0
 */
class EventsControllerDtoDrawItemDetailRequest {
    /**
     * Constructs a new <code>EventsControllerDtoDrawItemDetailRequest</code>.
     * @alias module:model/EventsControllerDtoDrawItemDetailRequest
     */
    constructor() { 
        
        EventsControllerDtoDrawItemDetailRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>EventsControllerDtoDrawItemDetailRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/EventsControllerDtoDrawItemDetailRequest} obj Optional instance to populate.
     * @return {module:model/EventsControllerDtoDrawItemDetailRequest} The populated <code>EventsControllerDtoDrawItemDetailRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new EventsControllerDtoDrawItemDetailRequest();

            if (data.hasOwnProperty('drawItemNo')) {
                obj['drawItemNo'] = ApiClient.convertToType(data['drawItemNo'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>EventsControllerDtoDrawItemDetailRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>EventsControllerDtoDrawItemDetailRequest</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Number} drawItemNo
 */
EventsControllerDtoDrawItemDetailRequest.prototype['drawItemNo'] = undefined;






export default EventsControllerDtoDrawItemDetailRequest;

